import React, { createContext, useState } from 'react';
import type { CountContextValue, Counts } from '@app-types/context';

// eslint-disable-next-line react-refresh/only-export-components
export const CountContext = createContext<CountContextValue | null>(null);

export const CountProvider = ({ children }: { children: React.ReactNode }) => {
  const [counts, setCounts] = useState<Counts>({
    totalCount: 0,
  });

  const updateCount = (key: string, value: number) => {
    setCounts((prevCounts) => ({
      ...prevCounts,
      [key]: value,
    }));
  };

  return (
    <CountContext.Provider value={{ counts, updateCount }}>
      {children}
    </CountContext.Provider>
  );
};
